import { render, staticRenderFns } from "./Glzd.vue?vue&type=template&id=0dd70555&scoped=true&"
import script from "./Glzd.vue?vue&type=script&lang=js&"
export * from "./Glzd.vue?vue&type=script&lang=js&"
import style0 from "./Glzd.vue?vue&type=style&index=0&id=0dd70555&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0dd70555",
  null
  
)

export default component.exports